'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ./~/_react-slick@0.15.4@react-slick/lib/index.js
// module id = 798
// module chunks = 0 1